import { render, staticRenderFns } from "./ModalNewTranslation.vue?vue&type=template&id=8193f282&"
import script from "./ModalNewTranslation.vue?vue&type=script&lang=js&"
export * from "./ModalNewTranslation.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports